export function popoverState() {
    var directive = {
        link: link,
        restrict: 'A',
        scope: {
            popoverState: '='
        }
    };
    return directive;

    function link(scope, element) {
        scope.$watch('popoverState', function(trigger) {
            if(trigger) {
                element.popover('show');
            } else {
                element.popover('hide');
            }
        });
    }
}
popoverState.$inject = [];
